module.exports = __webpack_public_path__ + "img/9791166680106.8394b7ee.jpg";